import React, { useState, useContext, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Badge,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  useMediaQuery,
  useTheme,
  Slide,
} from "@mui/material";
import {
  Notifications,
  ArrowBack,
  DarkMode,
  LightMode,
  Menu as MenuIcon,
  Work as WorkIcon,
} from "@mui/icons-material";
import { Alert } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TodayIcon from "@mui/icons-material/Today";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContextProvider";
import { logoutUser, fetchAuthRoots, fetchProfileCompletion } from "../../../services/apiService";
import DailySessions from "./DailySessions"; // Import the DailySessions component
import ShiftActions from "./Shift/ShiftActions"; // Import the ShiftActions component
import { checkActiveDailySession } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/SessoinAndShiftsApi";
import { fetchServiceAndTaxSettings } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";
import { getActiveShiftData, getActiveDailySessionData } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/SessoinAndShiftsApi";
import NotificationList from "./notification";
import { fetchNotifications } from "../../../services/Notification/NotificationApi";
import { useAuth } from "../../../context/AuthContext";
import useInternetStatus from "../../../components/useInternetStatus";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Navbar = ({ isSidebarOpen, toggleSidebar }) => {
  const [anchorElNotifications, setAnchorElNotifications] = useState(null);
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [username, setUsername] = useState("");
  const [branchName, setBranchName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [branches, setBranches] = useState([]);
  const [branchDialogOpen, setBranchDialogOpen] = useState(false);
  const [selectedBranchId, setSelectedBranchId] = useState(localStorage.getItem("branch_id") || "");
  const [dailyStarted, setDailyStarted] = useState(() => {
    return localStorage.getItem("daily_started") === "true";
  });
  const [dailyDate, setDailyDate] = useState(() => {
    const stored = localStorage.getItem("daily_date");
    return stored || new Date().toLocaleDateString("ar-EG");
  });
  const [anchorElDaily, setAnchorElDaily] = useState(null);
  const [dailyDialogOpen, setDailyDialogOpen] = useState(false); // State to control DailySessions dialog
  const [shiftDialogOpen, setShiftDialogOpen] = useState(false); // State to control ShiftActions dialog
  const [sessionType, setSessionType] = useState(""); // حالة اليومية من الإعدادات
  const [activeDailySessionDate, setActiveDailySessionDate] = useState("");

  const navigate = useNavigate();
  const { mode, toggleTheme } = useContext(ThemeContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isDailyActive, setIsDailyActive] = useState(true);
  const [isLoadingDailyStatus, setIsLoadingDailyStatus] = useState(true);
  const [showShiftAlert, setShowShiftAlert] = useState(false);
  const { logout } = useAuth();

  // NEW: states for plan renewal alert
  const [planData, setPlanData] = useState(null);
  const [renewCountdown, setRenewCountdown] = useState("");
  const [showRenewAlert, setShowRenewAlert] = useState(false);
  const [isRenewExpired, setIsRenewExpired] = useState(false);
  const isOnline = useInternetStatus();


  // احصل على التوكن من localStorage
  const token = localStorage.getItem("token");
  const [unseenCount, setUnseenCount] = useState(0);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setUsername(localStorage.getItem("username") || "مستخدم");
    setBranchName(localStorage.getItem("branch_name") || "فرع غير محدد");
    setAvatar(user.image || "");

    const loadBranches = async () => {
      try {
        const data = await fetchAuthRoots();
        setBranches(Array.isArray(data) ? data : []);
      } catch (err) {
        setBranches([]);
      }
    };
    loadBranches();

    // NEW: load plan data for renewal alerts
    const loadPlan = async () => {
      try {
        const res = await fetchProfileCompletion();
        const payload = res?.data ?? res;
        const plane = payload?.plane ?? payload;
        setPlanData(plane || null);
      } catch (err) {
        setPlanData(null);
      }
    };
    loadPlan();

    // جلب حالة اليومية من الإعدادات
    fetchServiceAndTaxSettings()
      .then(async (data) => {
        setSessionType(data.session || "");
        // تحقق من حالة الشيفت المطلوبة فقط إذا كانت اليومية ليست تلقائية
        if (data.session !== "automatic" && data.shift === "required") {
          try {
            const activeShifts = await getActiveShiftData();
            if (!activeShifts || activeShifts.length === 0) {
              setShowShiftAlert(true);
            } else {
              setShowShiftAlert(false);
            }
          } catch {
            setShowShiftAlert(true);
          }
        } else {
          setShowShiftAlert(false);
        }
      })
      .catch(() => setSessionType(""));
  }, []);

  // NEW: countdown effect for plan renewal (updates every second)
  useEffect(() => {
    const plane = planData;
    if (!plane?.end_date) {
      setRenewCountdown("");
      setShowRenewAlert(false);
      setIsRenewExpired(false);
      return;
    }

    const endDate = new Date(`${plane.end_date}T23:59:59`);
    let intervalId = null;

    const update = () => {
      const now = new Date();
      const diff = endDate - now;
      if (diff <= 0) {
        setIsRenewExpired(true);
        setShowRenewAlert(true);
        setRenewCountdown("00 يوم 00:00:00");
        return;
      }

      setIsRenewExpired(false);
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const rem = diff % (1000 * 60 * 60 * 24);
      const hours = Math.floor(rem / (1000 * 60 * 60));
      const minutes = Math.floor((rem % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((rem % (1000 * 60)) / 1000);

      setRenewCountdown(
        `${days} يوم ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      );

      // show alert when 10 days or less
      setShowRenewAlert(days <= 10);
    };

    update();
    intervalId = setInterval(update, 1000);
    return () => clearInterval(intervalId);
  }, [planData]);

  useEffect(() => {
    // جلب عدد الإشعارات غير المقروءة
    const loadUnseenNotifications = async () => {
      if (!token) return;
      try {
        const res = await fetchNotifications(token);
        const notifications = res?.data?.notifications || [];
        const unseen = notifications.filter(n => !n.seen).length;
        setUnseenCount(unseen);
      } catch {
        setUnseenCount(0);
      }
    };
    loadUnseenNotifications();
  }, [token]);

  const notifications = [
    "طلب جديد تم إضافته",
    "تم تحديث حالة طلبك",
    "إشعار جديد من الإدارة"
  ];

const handleLogout = () => {
  logout(); // 👈 ده هيعمل clear ويخلي isAuthenticated=false
};


  const handleBranchChange = (e) => {
    const branchId = e.target.value;
    const branch = branches.find(b => String(b.id) === String(branchId));
    setSelectedBranchId(branchId);
    localStorage.setItem("branch_id", branchId);
    localStorage.setItem("branch_name", branch?.name || ""); // تغيير اسم الفرع في اللوكال استورج بناءً على branch_id
    setBranchName(branch?.name || ""); // تغيير اسم الفرع في الواجهة
    setBranchDialogOpen(false);
    window.location.reload(); // إعادة تحميل الصفحة لتطبيق التغيير
  };

  const handleDailyMenuClick = () => {
    setDailyDialogOpen(true); // Open the DailySessions dialog
  };

  const handleDailyDialogClose = () => {
    setDailyDialogOpen(false); // Close the DailySessions dialog
  };

  const handleShiftMenuClick = () => {
    setShiftDialogOpen(true); // Open the ShiftActions dialog
  };

  const handleShiftDialogClose = () => {
    setShiftDialogOpen(false); // Close the ShiftActions dialog
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        background: mode === "dark"
          ? "rgba(30, 30, 30, 0.8)"
          : "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(10px)",
        color: mode === "dark" ? "#fff" : "#000",
        boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
        zIndex: 1201,
      }}
    >
      <Toolbar 
        sx={{ 
          display: "flex", 
          justifyContent: "space-between", 
          flexWrap: "wrap",
          minHeight: { xs: 56, sm: 64 },
          px: { xs: 1, sm: 2 },
        }}
      >
        {/* التنبيهات - صف منفصل داخل الـ Toolbar */}
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
          {!isDailyActive && !isLoadingDailyStatus && (
            <Box sx={{ 
              backgroundColor: "#f44336", 
              color: "#fff", 
              textAlign: "center", 
              py: 0.5, 
              fontSize: { xs: 11, sm: 13, md: 14 },
              px: 1,
            }}>
              <Typography fontWeight="bold" fontSize="inherit">⚠️ برجاء تفعيل اليومية أولاً</Typography>
            </Box>
          )}
          {showShiftAlert && (
            <Box sx={{ 
              backgroundColor: "#ff9800", 
              color: "#fff", 
              textAlign: "center", 
              py: 0.5, 
              fontSize: { xs: 11, sm: 13, md: 14 },
              px: 1,
            }}>
              <Typography fontWeight="bold" fontSize="inherit">
                {isSmallMobile ? "⚠️ فتح شيفت مطلوب" : "⚠️ برجاء فتح شيفت قبل البدء بالعمل والتاكد من تفعيل اليومية"}
              </Typography>
            </Box>
          )}
          {(() => {
            if (!planData) return null;
            if (isRenewExpired) {
              return (
                <Box sx={{ 
                  backgroundColor: "#d32f2f", 
                  color: "#fff", 
                  textAlign: "center", 
                  py: 0.5, 
                  fontSize: { xs: 11, sm: 13, md: 14 },
                  px: 1,
                }}>
                  <Typography fontWeight="bold" fontSize="inherit">
                    {isSmallMobile 
                      ? `⚠️ انتهت باقتك ${planData.end_date}` 
                      : `⚠️ انتهت باقتك (${planData.plane_name || "باقة"}) بتاريخ ${planData.end_date}. الرجاء التجديد فوراً.`
                    }
                  </Typography>
                </Box>
              );
            }
            if (showRenewAlert) {
              return (
                <Box sx={{ 
                  backgroundColor: "#FFB300", 
                  color: "#000", 
                  textAlign: "center", 
                  py: 0.5, 
                  fontSize: { xs: 11, sm: 13, md: 14 },
                  px: 1,
                }}>
                  <Typography fontWeight="bold" fontSize="inherit">
                    {isSmallMobile
                      ? `⏳ باقي ${renewCountdown}`
                      : `⏳ باقتك (${planData.plane_name || "باقة"}) ستنتهي بعد ${renewCountdown} (حتى ${planData.end_date}) — الرجاء التواصل مع الدعم الفني.`
                    }
                  </Typography>
                </Box>
              );
            }
            return null;
          })()}
        </Box>

        {/* يسار الشاشة */}
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, sm: 1, md: 2 } }}>
          <IconButton 
            color="inherit" 
            onClick={isMobile ? toggleSidebar : () => navigate(-1)}
            size={isSmallMobile ? "small" : "medium"}
          >
            {isMobile ? <MenuIcon /> : <ArrowBack />}
          </IconButton>
        </Box>

        {/* يمين الشاشة: تحكمات */}
        <Box sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: { xs: 0.5, sm: 1, md: 2 },
          flexWrap: isMobile ? "wrap" : "nowrap",
        }}>
          <IconButton 
            color="inherit" 
            onClick={toggleTheme}
            size={isSmallMobile ? "small" : "medium"}
          >
            {mode === "dark" ? <LightMode /> : <DarkMode />}
          </IconButton>

          {/* أيقونة اليومية */}
          {sessionType !== "automatic" && (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <IconButton
                color={dailyStarted ? "success" : "inherit"}
                onClick={handleDailyMenuClick}
                size={isSmallMobile ? "small" : "medium"}
                sx={{
                  bgcolor: dailyStarted ? "#4CAF50" : "transparent",
                  color: dailyStarted ? "#fff" : undefined,
                  transition: "background 0.2s, color 0.2s"
                }}
              >
                <TodayIcon fontSize={isSmallMobile ? "small" : "medium"} />
              </IconButton>
              {activeDailySessionDate && !isSmallMobile && (
                <Typography variant="caption" sx={{ fontSize: { xs: 9, sm: 10, md: 12 }, color: "#1976d2", fontWeight: "bold", mt: 0.5 }}>
                  {isMobile ? activeDailySessionDate : `تاريخ اليومية النشطة: ${activeDailySessionDate}`}
                </Typography>
              )}
            </Box>
          )}

          {/* زر تبديل الفروع */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <IconButton 
              color="inherit" 
              onClick={() => setBranchDialogOpen(true)}
              size={isSmallMobile ? "small" : "medium"}
            >
              <SwapHorizIcon fontSize={isSmallMobile ? "small" : "medium"} />
            </IconButton>
            {!isSmallMobile && (
              <Typography variant="caption" sx={{ fontSize: { xs: 9, sm: 10, md: 11 }, mt: -0.5 }}>
                {isMobile ? "الفروع" : "تبديل الفروع"}
              </Typography>
            )}
          </Box>

          {/* Shift Icon */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <IconButton
              color="inherit"
              onClick={handleShiftMenuClick}
              size={isSmallMobile ? "small" : "medium"}
            >
              <WorkIcon fontSize={isSmallMobile ? "small" : "medium"} />
            </IconButton>
            {!isSmallMobile && (
              <Typography variant="caption" sx={{ fontSize: { xs: 9, sm: 10, md: 11 }, mt: -0.5 }}>
                الشيفت
              </Typography>
            )}
          </Box>

          {/* الإشعارات */}
          <IconButton 
            color="inherit" 
            onClick={(e) => setAnchorElNotifications(e.currentTarget)}
            size={isSmallMobile ? "small" : "medium"}
          >
            <Badge badgeContent={unseenCount} color="error">
              <Notifications fontSize={isSmallMobile ? "small" : "medium"} />
            </Badge>
          </IconButton>

          <Menu
            anchorEl={anchorElNotifications}
            open={Boolean(anchorElNotifications)}
            onClose={() => setAnchorElNotifications(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{ 
              style: { 
                minWidth: isMobile ? 280 : 350, 
                maxHeight: 400, 
                padding: 0 
              } 
            }}
          >
            <NotificationList token={token} />
          </Menu>

          {!isSmallMobile && (
            <Box sx={{ textAlign: "right", mr: 1, display: { xs: "none", sm: "block" } }}>
              <Typography fontWeight="bold" fontSize={{ xs: "12px", sm: "13px", md: "14px" }}>{username}</Typography>
              <Typography variant="caption" fontSize={{ xs: "10px", sm: "11px" }}>📍 {branchName}</Typography>
            </Box>
          )}

          <IconButton 
            color="inherit" 
            onClick={(e) => setAnchorElProfile(e.currentTarget)}
            size={isSmallMobile ? "small" : "medium"}
          >
            <Avatar 
              src={avatar} 
              sx={{ 
                bgcolor: "#ff85b3",
                width: { xs: 32, sm: 36, md: 40 },
                height: { xs: 32, sm: 36, md: 40 },
              }}
            >
              {username?.charAt(0) || "ع"}
            </Avatar>
          </IconButton>

          <Menu
            anchorEl={anchorElProfile}
            open={Boolean(anchorElProfile)}
            onClose={() => setAnchorElProfile(null)}
          >
            <MenuItem>ملفي الشخصي</MenuItem>
            <MenuItem>الإعدادات</MenuItem>
            <MenuItem onClick={() => setOpenDialog(true)}>تسجيل الخروج</MenuItem>
          </Menu>
        </Box>
      </Toolbar>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} TransitionComponent={Transition}>
        <DialogTitle textAlign="center">هل أنت متأكد من تسجيل الخروج؟</DialogTitle>
        <DialogContent>
          <Typography textAlign="center">
            سيتم إنهاء الجلسة الحالية والعودة إلى صفحة الدخول.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} variant="outlined">
            إلغاء
          </Button>
          <Button onClick={handleLogout} color="error" variant="contained">
            نعم، تسجيل الخروج
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog لاختيار الفرع */}
      <Dialog open={branchDialogOpen} onClose={() => setBranchDialogOpen(false)}>
        <DialogTitle sx={{ fontWeight: "bold", color: "#EA7C69" }}>تغيير الفرع</DialogTitle>
        <DialogContent>
          <Box sx={{ minWidth: 250, mt: 1 }}>
            <Typography sx={{ mb: 1 }}>اختر الفرع الحالي:</Typography>
            <select
              value={selectedBranchId}
              onChange={handleBranchChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "1rem",
                marginBottom: "10px"
              }}
            >
              <option value="" disabled>اختر الفرع</option>
              {branches.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.name}
                </option>
              ))}
            </select>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBranchDialogOpen(false)} variant="outlined">إغلاق</Button>
        </DialogActions>
      </Dialog>

      {/* DailySessions Dialog */}
      <Dialog open={dailyDialogOpen} onClose={handleDailyDialogClose} fullWidth maxWidth="sm">
        <DialogTitle>إدارة اليومية</DialogTitle>
        <DialogContent>
          <DailySessions /> {/* Render the DailySessions component */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDailyDialogClose} variant="outlined">
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>

      {/* ShiftActions Dialog */}
      <Dialog open={shiftDialogOpen} onClose={handleShiftDialogClose} fullWidth maxWidth="sm">
        <DialogTitle>إدارة الشيفت</DialogTitle>
        <DialogContent>
          <ShiftActions /> {/* Render the ShiftActions component */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleShiftDialogClose} variant="outlined">
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
};

export default Navbar;
